import React from 'react';
import { motion } from 'framer-motion';
import { LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { CtaButton } from './ui/CtaButton';
import { OFFER_ANCHOR, PACK_IMAGE, PRODUCT_NAME } from '../data/content';
const EASE = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  return <header className="border-b-2 border-volt bg-canvas" data-id="element-94" data-mp="4mi2n8mfxkdf">
      <div className="mx-auto max-w-2xl px-3 pb-5 pt-4 text-center sm:px-5" data-id="element-95" data-mp="4jvvvb7dj8w9">
        <motion.p initial={{
        opacity: 0,
        y: -6
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.25,
        ease: EASE
      }} className="inline-flex items-center gap-1.5 rounded-full border border-cyan/50 bg-cyan-soft px-2.5 py-1 font-display text-[0.6rem] font-bold uppercase tracking-[0.14em] text-cyan" data-id="element-96" data-mp="128z0qg300208">
          <LockIcon size={11} data-id="element-97" data-mp="3d21uc37gquqd" />
          Método de aprendizaje paso a paso
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: EASE,
        delay: 0.04
      }} className="mt-2 font-display text-[1.35rem] font-black uppercase leading-[1.1] text-ink sm:text-3xl" data-id="element-98" data-mp="381xmt2oj9aca">
          El sistema completo para aprender{' '}
          <span className="text-cyan" data-id="element-99" data-mp="399tdr28qeocc">control de acceso y cerraduras</span>{' '}
          inteligentes desde cero
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: EASE,
        delay: 0.08
      }} className="mx-auto mt-2 max-w-xl text-[0.82rem] leading-snug text-ink-muted sm:text-[0.95rem]" data-id="element-100" data-mp="3eb91j22an8yf">
          Aprende una habilidad técnica actual, comprende cómo funcionan los
          sistemas de acceso y prepárate para comenzar a ofrecer este servicio —
          sin perderte entre cientos de videos, equipos y tutoriales.
        </motion.p>

        <motion.p initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.25,
        ease: EASE,
        delay: 0.12
      }} className="mt-2.5 inline-flex items-center gap-1.5 rounded-md bg-volt px-3 py-1.5 font-display text-[0.65rem] font-black uppercase leading-tight tracking-wide text-ink sm:text-xs" data-id="element-101" data-mp="2lla9cxssyvpj">
          <LockIcon size={12} data-id="element-102" data-mp="dd592bfyguxs" />
          {PRODUCT_NAME} · 6 Tomos + 5 Bonos
        </motion.p>

        <motion.a href={OFFER_ANCHOR} initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        ease: EASE,
        delay: 0.16
      }} className="mt-2.5 block overflow-hidden rounded-xl border-2 border-volt bg-canvasAlt" data-id="element-103" data-mp="1b0vv3f9nj4di">
          <img src={PACK_IMAGE} alt={`${PRODUCT_NAME}: 6 tomos digitales y 5 bonos incluidos`} className="block w-full" data-id="element-104" data-mp="x1nuqj1r5q7q" />
        </motion.a>

        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: EASE,
        delay: 0.2
      }} className="mt-3" data-id="element-105" data-mp="3hrdbj1m0nm32">
          <CtaButton href={OFFER_ANCHOR} size="lg" data-id="element-106" data-mp="21amvn8ncdqlt">
            🚀 Sí, quiero comenzar ahora
          </CtaButton>

          <p className="mt-2 flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-[0.68rem] font-semibold text-ink-muted" data-id="element-107" data-mp="269r41x2fzkb3">
            <span className="flex items-center gap-1" data-id="element-108" data-mp="2b2al540c8xkn">
              <ZapIcon size={12} className="text-cyan" data-id="element-109" data-mp="2g0c29je7emth" />
              Acceso Digital Inmediato
            </span>
            <span className="text-ink-subtle" data-id="element-110" data-mp="2kxubzc01p62j">•</span>
            <span className="flex items-center gap-1" data-id="element-111" data-mp="2l0qc96zd86u5">
              <ShieldCheckIcon size={12} className="text-success" data-id="element-112" data-mp="2p1scnr50qoxp" />
              Garantía de 7 Días
            </span>
          </p>
        </motion.div>
      </div>
    </header>;
}